import { makeStyles } from "@material-ui/core";

let primary = "#00a16b";

export const commonStyle = makeStyles((theme) => ({
  pageFormFooter: {
    position: "sticky",
    bottom: 0,
    borderTop: `1px solid #bebebe`,
    width: "100%",
    marginTop: 24,
    zIndex: 40,
    backgroundColor: "#fff",
  },
  flexBetweeen: {
    display: "flex",
    gap: "6px",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "10px",
    zIndex: 100,
  },
  flexCenter: {
    display: "flex",
    alignItems: "center",
  },
  flexTop: {
    display: "flex",
    alignItems: "flex-start",
  },
  flexCenterBetween: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  flexCenterGap: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  flexBox: {
    display: "flex",
    flexWrap: "wrap",
    margin: "-10px",
  },
  flexItemAuto: {
    width: "auto",
    padding: 10,
  },
  flexItemLG: {
    width: "100%",
    padding: 10,
  },
  flexItem90: {
    width: "90%",
    padding: 10,
  },
  flexItem10: {
    width: "10%",
    padding: 10,
  },
  flexItemMD: {
    width: "50%",
    padding: 10,
  },
  flexItemXMD: {
    width: "40%",
    padding: 10,
  },
  flexItem3x: {
    width: "75%",
    padding: 10,
  },
  flexItem2x: {
    width: "50%",
    padding: 10,
  },
  flexItem1x: {
    width: "25%",
    padding: 10,
  },
  flexItemXSM: {
    width: "20%",
    padding: 10,
  },
  flexItem: {
    width: "100%",
    padding: "0px 10px",
  },
  formInput: {
    width: "100%",
  },
  formInputSM: {
    width: "25%",
  },
  formInputMD: {
    width: "50%",
  },
  formInputLG: {
    width: "75%",
  },
  flexItemXL: {
    width: "60%",
    padding: 10,
  },
  flexItemSM: {
    width: "33.3%",
    padding: 10,
  },
  flexItem6x: {
    width: "16.6%",
    padding: 10,
  },
  flexItemSMM: {
    width: "25%",
    padding: 10,
  },

  flexItem2x1: {
    width: "20%",
  },
  flexItem2x2: {
    width: "40%",
  },
  flexItem2x3: {
    width: "60%",
  },
  flexItem2x4: {
    width: "80%",
  },
  flexItem2x5: {
    width: "100%",
  },
  flexPadding: {
    padding: "10px",
  },
  tableLabel: {
    ...theme.typography.body2,
  },
  tableValue: {
    ...theme.typography.body2,
    ...theme.typography.semiBold,
  },
  modalFooter: {
    borderTop: `1px solid #919191`,
    display: "flex",
    justifyContent: "flex-end",
    padding: `12px 15px`,
  },
  modalHeader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "12px 0px",
    borderBottom: `1px solid #919191`,
    position: "relative",
  },
  modalMsgFooter: {
    borderTop: `1px solid #919191`,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    padding: `12px 15px`,
    textAlign: "right",
    width: "100%",
  },
  modalheaderTitle: {
    ...theme.typography.h3,
    ...theme.typography.bold,
  },
  modalIconBtn: {
    position: "absolute",
    right: "10px",
  },
  errorText: {
    color: "#f44336",
    margin: 0,
    marginLeft: `14px`,
    marginRight: `14px`,
  },
  accordionHeader: {
    ...theme.typography.h5,
    fontWeight: 700,
    margin: 0,
  },
  accordionActionHeader: {
    display: "flex",
    justifyContent: "space-between",
    margin: 0,
  },
  dialogTitleBox: {
    borderBottom: "1px solid rgb(213, 205, 205)",
  },
  dialogTitle: {
    textAlign: "center",
    textTransform: "capitalize",
    margin: 0,
  },
  titleBox: {
    borderTop: "1px solid rgb(213, 205, 205)",
    borderBottom: "1px solid rgb(213, 205, 205)",
    padding: "10px 0px",
  },
  title: {
    textTransform: "capitalize",
    margin: 0,
  },
  emptyText: {
    fontFamily: "Mulish",
    fontStyle: "italic",
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "23px",
    color: "#16191f",
    fontStyle: "italic",
  },
  filterOption: {
    ...theme.typography.body2,
  },
  loaderWrap: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: `260px`,
    width: "100%",
  },
  emptyCard: {
    backgroundColor: "#fff",
    textAlign: "center",
    ...theme.border,
    borderRadius: 4,
  },
  card: {
    backgroundColor: "#fff",
    padding: 12,
    marginTop: 18,
    borderRadius: 5,
    marginLeft: 2,
    marginRight: 2,
  },
  label: {
    ...theme.typography.h6,
    ...theme.typography.semiBold,
    display: "block",
  },
  cardHeader: {
    ...theme.typography.h5,
    ...theme.typography.semiBold,
  },
  cardSubtitle: {
    ...theme.typography.h6,
  },
  cHeaderWrap: {
    ...theme.borderBottom,
    paddingBottom: 12,
  },
  tabScrollerWrap: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: `0px 4px`,
  },
  guidelineHeader: {
    ...theme.typography.body2,
    ...theme.typography.semiBold,
    fontStyle: "italic",
    opacity: 0.8,
    textDecoration: "underline",
    textUnderlineOffset: "3px",
  },
  guideList: {
    margin: 0,
    padding: 0,
    paddingLeft: "16px",
  },
  guideText: {
    ...theme.typography.body2,
    fontStyle: "italic",
    opacity: 0.9,
  },
}));
